import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import { Navigate, useLocation } from "react-router-dom"
import axios from "axios"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import Snackbar from "@mui/material/Snackbar"
import Alert from "@mui/material/Alert"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import { useSelector } from "react-redux"
import { logOut } from "../../../utils/logOut"
import TranslatedText from "../../../utils/Translate"
import { useSnackbar } from "../../../utils/SnackbarContext"

export default function ContactGroup() {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [snackbarType, setSnackbarType] = useState("")
    const [partners, setSPartners] = useState([])

    const { showSnackbar } = useSnackbar();

    //Get params from URL
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const type: string | null = params.get('type')

    //Get access level
    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    //Switch header title

    useEffect(() => {
        dispatch(setCurrentPage(type === "edit" ? `Edit contact group` : 'Add contact group'))
    }, [dispatch]);

    //Handle close snackbar
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    //Get contact group
    async function fetchData(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/contactgroup/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            if (response.data !== null) {
                setcontactGroupData(response.data[0])
            }

            console.log(response.data[0]);

        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Create contact group
    async function postData(data: any = {}) {
        try {
            const response = await axios.post(`https://cardgarantsales.com/restapi/contactgroup`, {
                leadgroupcode: data.leadgroupcode,
                leadgroupname: data.leadgroupname,
                partner: data.partner,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Edit contact group
    async function putData(data: any = {}) {
        try {
            const response = await axios.put(`https://cardgarantsales.com/restapi/contactgroup/${id}`, {
                leadgroupcode: data.leadgroupcode,
                leadgroupname: data.leadgroupname,
                partner: data.partner,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    const [contactGroupData, setcontactGroupData] = useState<any>(type === 'edit' ? [] :
        {
            "id": null,
            "leadgroupcode": null,
            "leadgroupname": null,
            "partner": null
        }
    )

    //Get partners for Select field
    async function getPartners(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/partner`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setSPartners(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }


    //On load if URL params contains type=edit - get contactgroup data, if accesslevel = 5 - get partners for Select field
    useEffect(() => {
        type === 'edit' && fetchData()
        accesslevel === "5" && getPartners()
        console.log(contactGroupData);

    }, [])

    return (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <Box>
                <Box sx={{ width: 350, display: "flex", mb: 2, flexWrap: "wrap", gap: 2 }}>
                    <TextField sx={{ width: '100%' }} error={contactGroupData.leadgroupcode === null} onChange={(e) => setcontactGroupData({ ...contactGroupData, leadgroupcode: e.target.value !== '' ? e.target.value : null })} value={contactGroupData.leadgroupcode || ''} variant="outlined" size="small" label={<span><TranslatedText text={"Lead group code"} />*</span>} />
                    <TextField sx={{ width: '100%' }} onChange={(e) => setcontactGroupData({ ...contactGroupData, leadgroupname: e.target.value !== '' ? e.target.value : null })} value={contactGroupData.leadgroupname || ''} variant="outlined" size="small" label={<TranslatedText text={'Lead group name'} />} />
                    {Number(accesslevel) === 5 &&
                        <>
                            <FormControl sx={{ width: '100%' }} >
                                <InputLabel size="small" id="simple-select-label"><TranslatedText text={"Partner"} /></InputLabel>
                                <Select sx={{ width: '100%' }} labelId="simple-select-label" onChange={(e) => setcontactGroupData({ ...contactGroupData, partner: e.target.value !== "" ? e.target.value : null })} value={contactGroupData.partner || ''} variant="outlined" size="small" label={<TranslatedText text={"Partner"} />} >
                                    <MenuItem value={''}><TranslatedText text={"Not selected"} /></MenuItem>
                                    {
                                        partners.map((el: any) => {
                                            return (
                                                <MenuItem key={el.id} value={el.id}>{el.partnerbankcode}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                        </>
                    }
                </Box>
                <Button onClick={() => type === "edit" ? putData(contactGroupData) : postData(contactGroupData)} variant="contained" sx={{ width: "100%" }}><TranslatedText text={"Save"} /></Button>
            </Box>
            {type !== 'edit' && snackbarType === 'success' && <Navigate to='/contactgroups' />}
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleClose}>
                {snackbarType === 'error' ?
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                        <TranslatedText text={"Saving error"} />
                    </Alert> :
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                        <TranslatedText text={"Successfully saved"} />
                    </Alert>}
            </Snackbar>
        </Box >
    )
}